
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'common/components/elements/icons';
import GenerateColor from 'common/utils/generateTextColor.js'

const BackgroundWrapper = ({
   children,
   className = '',
   contentClass = '',
   style = {},
   settings,
   isMobile,
   isShowVerivicationCheckbox,
}) => {
   const backgroundSettings = isMobile ? settings?.mobile_background : settings?.desktop_background;

   const isParallax = isMobile ? settings?.mobile_background_scroll === 'parallax' : settings?.desktop_background_scroll === 'parallax';
   const getColor = (settings) => {
      let color = null;
      if(settings && 'color' === settings.type){
         color = settings.color;
      }
      return color;
   }
   const getIsDarkMode = () => {
      if('color' !== backgroundSettings.type) return false;
      const bgColor = backgroundSettings.color;
      return GenerateColor.isDarkMode(bgColor);
   }
   const getAspectRation = () => {
      const ration = isMobile ? settings?.mobile_background_ration : settings?.desktop_background_ration;
      const rationPercentage = {
         '1:1': '100%',
         'full_srceen': '100%',
         '16:8': '50.86%',
      }
      return rationPercentage[ration] || '50.86%'
   }

   const isCustomColor = (color) => {
      return color && !color.includes('bg-')
   }

   const parallaxStyle = () => {
      if(!isParallax){
         return {}
      }
      return {
         backgroundAttachment: 'fixed',
         // backgroundPosition: 'center',
         // backgroundSize: 'cover',
         // backgroundRepeat: 'no-repeat',
         transition: '1s opacity',
      }
   }

   const generateStyle = () => {
      let contentStyle = { style };
      const color = getColor(backgroundSettings);
      switch (backgroundSettings.type) {
         case 'color':{
            if(color){
               if(isCustomColor(color)){
                  contentStyle = {
                     ...contentStyle,
                     background: color,
                  }
               }
            }
            break;
         }
         case 'image':{
            if(backgroundSettings.image_full_src){
               if(isParallax){
                  contentStyle = {
                     ...contentStyle,
                     ...parallaxStyle(),
                  }
               }
            }
            break;
         }
         default:
            break;
      }

      return contentStyle
   }
   const generateClass = () => {
      const color = getColor(backgroundSettings);
      let className = '';
      if(!isCustomColor(color)){
         className = `${ className } ${ color }`
      }
      return className
   }

   return (
      <div
         style={ generateStyle() }
         className={ cx({
            [`${ className } ${ generateClass() } site-builder-transition overflow-hidden flex flex-col relative w-full bg-cover bg-center bg-no-repeat`]: true,
            'dark': getIsDarkMode(),
         }) }

      >
         <div
            style={ {
               paddingTop: getAspectRation(),
            } }
         />
         {
            backgroundSettings.opacity && (
               <div
                  style={ {
                     opacity: backgroundSettings.opacity,
                  } }
                  className='absolute w-full h-full inset-0 flex z-2 site-builder-transition bg-panel dark:bg-panel-dark'
               >
               </div>
            )
         }
         {
            'video' === backgroundSettings.type && (
               <div
                  className='absolute w-full h-full inset-0 flex z-1'>
                  <video
                     style={ {
                        objectFit: backgroundSettings.stretch_to_fit ? 'cover' : 'contain',
                        filter: ` blur(${ backgroundSettings.blur }px)`,
                        ...parallaxStyle(),
                     } }
                     autoPlay muted loop className='h-full w-full object-center'>
                     <source src={ backgroundSettings.video_full_src } ></source>
                     Your browser does not support HTML5 video.
                  </video>
               </div>
            )
         }
         {
            'image' === backgroundSettings.type && (
               <div
                  className='absolute w-full h-full inset-0 flex z-1'>
                  <div
                     alt=''
                     src={ backgroundSettings.image_full_src }
                     style={ {
                        backgroundImage: `url(${ backgroundSettings.image_full_src })`,
                        ...parallaxStyle(),
                        filter: ` blur(${ backgroundSettings.blur }px)`,
                        backgroundSize: backgroundSettings.stretch_to_fit ? 'cover' : 'contain',
                        backgroundPosition: 'center',

                     } }
                     autoPlay muted loop className='h-full w-full bg-no-repeat bg-center'>
                  </div>
               </div>
            )
         }
         <div
            style={ {
               alignItems: settings.alignment,
               textAlign: settings.alignment,
            } }
            className='flex flex-col w-full h-full gap-4 absolute top-0 left-0 justify-center px-6 py-8 z-[3]'>
            <div
               style={ {
                  alignItems: settings.alignment,
                  textAlign: settings.alignment,
               } }
               className={ `flex flex-1 flex-col gap-4 justify-center ${ contentClass }` }>
               {
                  settings.title && (
                     <span
                        className={ cx({
                           'font-semibold': true,
                           'text-[30px] leading-[38px]': isMobile,
                           'text-5xl leading-[60px]': !isMobile,
                           'text-major-dark': getIsDarkMode(),
                           'text-major dark:text-major-dark': !getIsDarkMode(),
                        }) }
                     >
                        {settings.title}
                     </span>

                  )
               }
               {
                  settings.description && (
                     <span
                        className={ cx({
                           'leading-[30px] max-w-full': isMobile,
                           'text-base leading-[20px] ': !isMobile,
                           'text-major-dark': getIsDarkMode(),
                           'text-major dark:text-major-dark': !getIsDarkMode(),
                        }) }
                        style={ {
                           textAlign: settings.description,
                        } }
                        dangerouslySetInnerHTML={ {
                           __html: settings.description,
                        } }
                     />

                  )
               }

               {children && children}

            </div>
            {
               isShowVerivicationCheckbox && (
                  <div className='flex gap-3 items-center'>
                     <div className='flex items-center justify-center w-10 h-10 rounded-lg border border-divider dark:border-divider bg-panel dark:bg-panel-dark'>
                        <Icon
                           name='verify-bold'
                           size='2xl'
                           color='action'
                        />
                     </div>

                     <span className='text-major-dark font-medium text-lg leading-[28px] dark:text-major'>Verified Official Site</span>
                  </div>
               )
            }

         </div>
      </div>
   )
}
BackgroundWrapper.propTypes = {
   className: PropTypes.string,
   children: PropTypes.any,
   settings: PropTypes.object,
   style: PropTypes.object,
   isMobile: PropTypes.bool,
   isShowVerivicationCheckbox: PropTypes.string,
   contentClass: PropTypes.string,
};
export default BackgroundWrapper;


